import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from "@ionic/angular";
import { analytics } from 'firebase';
import { AppService } from 'src/app/app.service';
import { CONSTANTS } from 'src/app/core/constants/constants';
import { UTILITIES } from "../../core/utility/utilities";
import { Storage } from "@ionic/storage";
import moment from 'moment';

@Component({
  selector: 'app-nutri-select-recipe',
  templateUrl: './nutri-select-recipe.component.html',
  styleUrls: ['./nutri-select-recipe.component.scss'],
})
export class NutriSelectRecipeComponent implements OnInit {
  guranteeData;
  foodCode:any;
  source='';
  portion:0;
  isIos =  this.utilities.isDeviceiOS();
  selectedDietPlan = CONSTANTS.selectedDietPlan
  isPlanActiveForDiet = CONSTANTS.isPlanActiveParent;
  foodSlots = [
    {
      name: "When You Wake up",
      value: 0,
      isSelected: 'checked'
    },
    {
      name: "Before Breakfast",
      value: 1,
      isSelected: 'checked'
    },
    {
      name: "Breakfast",
      value: 2,
      isSelected: 'checked'
    },
    {
      name: "Mid Day Meal",
      value: 3,
      isSelected: 'checked'
    },{
      name: "Lunch",
      value: 4,
      isSelected: false
    },{
      name: "Post Lunch",
      value: 5,
      isSelected: false
    },{
      name: "Evening Snacks",
      value: 6,
      isSelected: false
    },{
      name: "Dinner",
      value: 7,
      isSelected: false
    },
    {
      name: "Before Sleep",
      value: 8,
      isSelected: false
    }
  ];
  constructor(private storage:Storage, private route:Router ,public modalController: ModalController,
    private utilities: UTILITIES, private appService:AppService,public navParams: NavParams) {
      this.foodCode = navParams.get("componentProps");
      this.source = navParams.get("componentProps");
      this.portion = navParams.get("componentProps");

      console.log('isPlanActiveForDiet===>>',this.isPlanActiveForDiet);
       
    }

  ngOnInit() {
    
  }
 

  close(flag) {
    if(flag && this.slot!=0){
      let selectedSlot = this.foodSlots.filter((ele,i)=>{
        return ele.isSelected;
      });
      if(selectedSlot && selectedSlot.length > 0){
        let data = {
          selectedSlot : selectedSlot[0].value
        }
        this.modalController.dismiss(data);
      }else this.modalController.dismiss();
    }else{
      this.modalController.dismiss();
    }
  }
  selectedPref:any;
  slot:any=0;
  radioGroupChange(event) {
  console.log("radioGroupChange",event.detail.value,this.foodCode);
   console.log(this.dataParam[this.selectedDietPlan].diets);
    for (let k = 0; k < this.dataParam[this.selectedDietPlan].diets.length; k++) {
      console.log("comrate",this.dataParam[this.selectedDietPlan].diets[k].slot,Number(event.detail.value));
      if(this.dataParam[this.selectedDietPlan].diets[k].slot===Number(event.detail.value)){ 
       
          for (let index = 0; index < this.dataParam[this.selectedDietPlan].diets[k].data.length; index++) {
              const element = this.dataParam[this.selectedDietPlan].diets[k].data[index];
              this.previousFood.push({code:element.itemCode, portion: element.portion,foodSource:  element.foodSource, eaten: element.eaten ? element.eaten : -1});
            }
             break;
           }
        else{
          continue;
        }
      }
      this.previousFood.push({code:this.foodCode, portion: this.portion,foodSource:  this.source!==''?this.source:"INTERNAL",  eaten: 2});  
    console.log("All Food",[...this.previousFood]);
    this.slot=event.detail.value;
    // this.selectedPref ={
    //   code: [...this.previousFood,this.foodCode],
    //   portion: this.portion,
    //   foodSource:  this.source!==''?this.source:"INTERNAL"
    // };
  }
  previousFood=[];
  dataParam:any;
  ionViewWillEnter(){
    let data ={};
    this.storage.get("dietData").then((res)=>{
      console.log("res",res);
      // const asArray = Object.entries(res);
      // console.log("res",asArray);
      // data = asArray.filter(item=>{
      //      return item[0]===new Date().getDate()+''+(new Date().getMonth()+1)+''+new Date().getFullYear()
      // });
      this.dataParam = res[moment(new Date()).format("DDMMYYYY")];
    });
  }
  
  
    addFood(){
      console.log('previousFood==>>>',this.previousFood);
      if(this.previousFood.length > 0){
      this.utilities.logEvent("Tab_Discover_Recipe_FoodDetails_Add_Food", {});
      this.utilities.presentLoading();
        let reqBody = {
          foodCodeList: this.previousFood,
          slot: Number(this.slot),
          detox: CONSTANTS.isDetox,
          date: moment(new Date()).format("DDMMYYYY"),
          country: CONSTANTS.country
        };
        console.log("reqBody", reqBody);
       // this.utilities.logEvent("update_food_details_TodaysCaloriesCount", reqBody);
        this.appService.postOptionFoodList(reqBody).then(
          success => {
            console.log("succe4ss", success);
            this.appService.getDietPlans(CONSTANTS.isDetox,moment(new Date()).format("DDMMYYYY") , CONSTANTS.country, CONSTANTS.defaultCalories).then(
              success => {
                this.storage.get("dietData").then((val : any)=>{
                  let date = moment(new Date()).format("DDMMYYYY");
                  val[date] = {};
                  let planName = CONSTANTS.isDetox ? "detox" : CONSTANTS.selectedDietPlan;
                  val[date][planName] = success;
                  this.storage.set("dietData", val).then(()=>{
                    this.storage.set("optionsData", null).then(()=>{
                      this.utilities.hideLoader();
                      this.modalController.dismiss();
                      if(!this.isPlanActiveForDiet){
                        this.route.navigate(["consume"], { queryParams: { selectedSlot: this.slot}});
                      }
                      if(this.isPlanActiveForDiet){
                        this.route.navigate(["consume-v"], { queryParams: { selectedSlot: this.slot}});
                      }
                    })
                  })
                })
              })
          

          },
          err => {
            this.utilities.hideLoader();
            console.log("details error", err);
          }
        );
    
    }
    else{
      //alert("select some slot");
      this.utilities.showErrorToast('Please select any slot');
    }
    }

  slotSelected(slot,index){
    console.log("slot",slot);
    
    if(!slot["isSelected"]){
      this.foodSlots.filter((ele,i)=>{
        if(i == index){
            ele["isSelected"] = 'checked';
        }else{
          ele["isSelected"] = false;
        }
        return ele;
      });
    }else{
      this.foodSlots.filter((ele,i)=>{
        ele["isSelected"] = false;
        return ele;
      });
    }
  }
}

